import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  border-bottom: 2px solid ${({ theme }) => theme.colors.secondary};
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
`;

export default function FaqWrapper({ children }) {
  return (
    <Wrapper
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/FAQPage"
    >
      {children}
    </Wrapper>
  );
}

FaqWrapper.propTypes = {
  children: PropTypes.node,
};

FaqWrapper.defaultProps = {
  children: undefined,
};
